import React, { useMemo } from 'react';
import { createMaterialTopTabNavigator } from '@react-navigation/material-top-tabs';
import { useTheme } from '../../theme';
import { EmptyState, Screen, SegmentedTabBar } from '../../design/components';
import MachineSetupListView from './machine/MachineSetupListView';
import MarketSetupListView from './market/MarketSetupListView';
import LocationSetupListView from './location/LocationSetupListView';
import { PREDEFINED_USER_ROLES } from '../../../common/constants';
import { useUserContext } from '../../../common/utils/context';

const Tab = createMaterialTopTabNavigator();

const renderTabBar = props => <SegmentedTabBar {...props} />;

const SetupsTabView = () => {
	const { theme: { ui: { colors } } } = useTheme();
	const {
		user,
		isAVC,
		isDriver,
		canCompleteAssignedMarketSetups,
	} = useUserContext();
	const canAccessAllSetups = useMemo(() => user && (user.isSuperAdmin || (isAVC && user.role.name === PREDEFINED_USER_ROLES.ADMIN)), [user, isAVC]);
	const canAccessAssignedMachineSetups = Boolean(isDriver && !user?.isSuperAdmin && !canAccessAllSetups);
	const canAccessAssignedMarketSetups = Boolean(canCompleteAssignedMarketSetups && !user?.isSuperAdmin && !canAccessAllSetups);
	const screenOptions = useMemo(() => ({
		sceneStyle: { backgroundColor: colors.canvas },
		tabBarScrollEnabled: false,
		lazy: true,
	}), [colors.canvas]);

	if (canAccessAssignedMachineSetups || canAccessAssignedMarketSetups) {
		return (
			<Screen heading="Assigned setups" scroll={false}>
				<Tab.Navigator tabBar={renderTabBar} screenOptions={screenOptions}>
					{canAccessAssignedMachineSetups && (
						<Tab.Screen name="AssignedMachineSetups" options={{ tabBarLabel: 'Machine setups' }}>
							{() => <MachineSetupListView />}
						</Tab.Screen>
					)}
					{canAccessAssignedMarketSetups && (
						<Tab.Screen name="AssignedMarketSetups" options={{ tabBarLabel: 'Market setups' }}>
							{() => <MarketSetupListView />}
						</Tab.Screen>
					)}
				</Tab.Navigator>
			</Screen>
		);
	}

	if (!canAccessAllSetups) {
		return (
			<Screen heading="Setups">
				<EmptyState icon="lock" title="You do not have access to setups." />
			</Screen>
		);
	}

	return (
		<Screen heading="Setups" scroll={false}>
			<Tab.Navigator tabBar={renderTabBar} screenOptions={screenOptions}>
				<Tab.Screen
					name="LocationSetups"
					options={{ tabBarLabel: 'Location setups' }}
				>
					{() => <LocationSetupListView />}
				</Tab.Screen>
				<Tab.Screen
					name="MachineSetups"
					options={{ tabBarLabel: 'Machine setups' }}
				>
					{() => <MachineSetupListView />}
				</Tab.Screen>
				<Tab.Screen
					name="MarketSetups"
					options={{ tabBarLabel: 'Market setups' }}
				>
					{() => <MarketSetupListView />}
				</Tab.Screen>
			</Tab.Navigator>
		</Screen>
	);
};

export default SetupsTabView;
